// The product site (the animated original) owns every route. The brand-v2 waitlist landing is kept at /v2 (noindex) for reference.
const path = window.location.pathname;
if (path === "/v2" || path === "/v2/") void import("./waitlist/boot");
else void import("./legacy-boot");
